export type TileCoords = {
    x: number
    y: number
    z: number
}

export type Point = {
    lat: number
    lng: number
    zom: number
}

export function round(num: number, digits: number): number {
    let x = Math.pow(10, digits)
    return Math.round(num * x) / x
}

function degrees_to_radians(degrees: number): number {
    return degrees * (Math.PI / 180)
}

function radians_to_degrees(radians: number): number {
    return radians * (180 / Math.PI)
}

export function point_to_tile({ lat, lng, zom }: Point): TileCoords {
    let lat_rad = degrees_to_radians(lat)
    let z = ~~zom
    let n = Math.pow(2, z)
    let x = ~~(((lng + 180) / 360) * n)
    let y = ~~(((1.0 - Math.asinh(Math.tan(lat_rad)) / Math.PI) / 2.0) * n)
    return { x, y, z }
}

export function tile_to_point({ x, y, z }: TileCoords): Point {
    let n = Math.pow(2, z)
    let lng = (x / n) * 360 - 180
    let lat_rad = Math.atan(Math.sinh(Math.PI * (1 - (2 * y) / n)))
    let lat = radians_to_degrees(lat_rad)
    return { lat, lng, zom: z }
}

export function hex_le(hex: string): number | null {
    if (hex.length == 0) return 0
    if (hex.length % 2 != 0) return null

    let bytes = hex.length / 2
    let res = 0
    const HEXCHARS = '0123456789abcdefABCDEF'
    for (let i = 0; i < bytes; i++) {
        let n = hex.slice(i * 2, (i + 1) * 2)
        for (let c of n) {
            if (!HEXCHARS.includes(c)) return null
        }
        res |= parseInt(n, 16) << (i * 8)
    }
    return res
}
